// @ts-nocheck
import React, { useEffect } from "react";
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { Form, FormWithoutStyle } from "../Componentes/useForm";
import { useUsuarios } from "./State/UsuarioContext";
import FormInput from "../Componentes/FormInput";
import Grid from "@mui/material/Grid";
import Joi from "joi";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import { DialogContent as ModalContent } from '@mui/material';
import SinapTheme from "../styles/SinapTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useBody } from "../Body/state/BodyContext";
import { SaveButton } from "../Componentes/inputs/SaveButton";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { EXTENSION_MAIL_INSTITUCIONAL, RUTA_API_USUARIOS, URL_API_SIA } from "../Contantes/Constantes";
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import CircularIndeterminate from '../Componentes/CircularIndeterminate';
import LockIcon from '@mui/icons-material/Lock';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { useHistory } from "react-router-dom";
import dayjs from 'dayjs';
import { useFormulario } from "./State/FormularioState/FormularioContext";
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';


const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapTheme.palette.primary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > *': {
            margin: "8px",
        },
        flexGrow: 1,
        maxWidth: 752,
    },
    label: {
        paddingLeft: "16px",
        paddingTop: "14.4px"
    },
    header_forms: {
        textDecoration: 'underline'
    }
}))

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(nombre, personName, theme) {
    return {
        fontWeight: 2
    };
}

export const FormularioAlta = ({ isSolicitud, closeModal, type, mostrarLegajoAlumno, tab, prev, mostrarContrasena, ...props }) => {
    let history = useHistory();
    const theme = useTheme();
    const { provincias, paises, loading, setLoading, getAltasPendientes } = useUsuarios();
    const { setSexos, setFiliaciones, setSedes, setFechaNacimiento, setErrores, setValue, setTiposDocumentoDeIdentificacion, setEstadosCiviles,
        sexos, filiaciones, sedes, fechaNacimiento, errores, tiposDocumentoDeIdentificacion, estadosCiviles, value, resetearForm } = useFormulario();
    const { setMessage, setSuccess } = useBody();
    const [error, setError] = React.useState(0);
    const [errorMsg, setErrorMsg] = React.useState("");
    const [filiacionesSeleccionadas, setFiliacionesSeleccionadas] = React.useState([]);
    const [loadingg, setLoadingg] = React.useState(loading);
    const matches = useMediaQuery('(max-width:600px)');
    const classes = useStyles();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const validarNombreUsuario = (nombreUsuario) => {
        const regex = /^[a-zA-Z0-9]*$/;
        return regex.test(nombreUsuario);
    }

    const handleChangeFiliacionOption = (key, nombre) => {
        if (value.filiaciones.find(filiacion => filiacion.id === key)) {
            setFiliacionesSeleccionadas(filiacionesSeleccionadas.filter(filiacion => filiacion !== nombre))
            setValue(prev => ({
                ...prev,
                filiaciones: prev.filiaciones.filter(filiacion => filiacion.id !== key),
                Filiacions: prev.filiaciones.filter(filiacion => filiacion.id !== key)
            }))
        }
        else {
            setFiliacionesSeleccionadas(filiacionesSeleccionadas.concat(nombre))
            setValue(prev => ({
                ...prev,
                filiaciones: [...prev.filiaciones, ({ id: key, nombre: nombre })],
                Filiacions: [...prev.filiaciones, ({ id: key, nombre: nombre })]
            }))
        }
    }

    React.useEffect(() => {
        if (!isSolicitud) history.push({
            pathname: '/usuarios/alta',
            search: `?tab=${tab}`
        })

        axios({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/formulario/user/info`,
        })
            .then((response) => {
                mapearInformacion(response.data);
            })
            .catch(() => {
                setMessage("Ocurrio un error al querer obtener información del formulario (Codigo de error: 00036)");
            })
            .then(setLoadingg(false));

    }, [])

    React.useEffect(() => {
        if (prev !== undefined)
            if (prev.uid !== '') {
                let fecha = dayjs(prev.fechaNacimiento).$d.toString()

                delete prev.password
                delete prev.repeat_password

                setValue(({
                    ...prev,
                    fechaNacimiento: fecha,
                    DocumentoDeIdentificacion: {
                        id: prev.DocumentoDeIdentificacion.id,
                        numero: parseInt(prev.DocumentoDeIdentificacion.numero),
                        TipoDocumentoDeIdentificacionId: prev.DocumentoDeIdentificacion.TipoDocumentoDeIdentificacionId
                    },
                    Direccion: {
                        id: prev.Direccion.id,
                        calle: prev.Direccion.calle,
                        altura: prev.Direccion.altura,
                        ciudad: prev.Direccion.ciudad,
                        provincia: prev.Direccion.provincia,
                        codigoPostal: prev.Direccion.codigoPostal,
                    },
                    filiaciones: prev.Filiacions
                }))
                setFiliacionesSeleccionadas(prev.Filiacions.map(filiaciones => filiaciones.nombre))
                setFechaNacimiento(dayjs(prev.fechaNacimiento))
            }
    }, [prev])

    /**
     * La consulta de la API debería devolver 4 keys: filiaciones, sedes, generos y tiposDocumentoDeIdentificacion
     */
    const mapearInformacion = (response) => {
        if (response.filiaciones.length !== 0)
            setFiliaciones(response.filiaciones)
        else setMessage("Hubo un error al querer cargar las filiaciones")
        if (response.sedes.length !== 0)
            setSedes(response.sedes)
        else setMessage("Hubo un error al querer cargar las sedes")
        if (response.sexos.length !== 0)
            setSexos(response.sexos)
        else setMessage("Hubo un error al querer cargar los generos")
        if (response.tiposDocumentoDeIdentificacion.length !== 0)
            setTiposDocumentoDeIdentificacion(response.tiposDocumentoDeIdentificacion)
        else setMessage("Hubo un error al querer cargar los tipos de documento de identificacion")
        if (response.estadosCiviles.length !== 0)
            setEstadosCiviles(response.estadosCiviles)
        else setMessage("Hubo un error al querer cargar los tipos de estados civiles")
    }

    const handleValidation = async (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password
        if (passwordInputFieldName === 'password') {
            const uppercaseRegExp = /(?=.*?[A-Z])/;
            const lowercaseRegExp = /(?=.*?[a-z])/;
            const digitsRegExp = /(?=.*?[0-9])/;
            const minLengthRegExp = /.{8,}/;
            const passwordLength = passwordInputValue.length;
            const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
            const digitsPassword = digitsRegExp.test(passwordInputValue);
            const minLengthPassword = minLengthRegExp.test(passwordInputValue);
            let errmsg = "";
            if (passwordLength === 0) {
                errmsg = "La contraseña no puede ser vacia"
                await setError(0)
            } else if (!uppercasePassword) {
                errmsg = "La contraseña debe tener al menos una letra mayuscula";
                await setError(1)
            } else if (!lowercasePassword) {
                errmsg = "La contraseña debe tener al menos una letra minuscula";
                await setError(1)
            } else if (!digitsPassword) {
                errmsg = "La contraseña debe tener al menos un digito";
                await setError(1)
            } else if (!minLengthPassword) {
                errmsg = "La contraseña debe tener al menos 8 carácteres";
                await setError(1)
            } else {
                errmsg = "";
                await setError(0)
            }
            setErrorMsg(errmsg);

        }
    }

    const handleSubmit = async (e) => {
        const searchParams = new URLSearchParams(document.location.search)
        e.preventDefault();
        resetearErrores();
        let errorOnValidation = validateForm();
        if (errorOnValidation) {
            await scrollToTop();
            mensajeAlertaFalloFormulario(errorOnValidation);
            setErrores(prevState => ({
                ...prevState,
                [errorOnValidation]: true
            }))
            setLoading(false);
            return;
        }
        if (value.password !== value.repeat_password && mostrarContrasena) {
            setErrores(prevState => ({
                ...prevState,
                password: true,
                repeat_password: true
            }))
            setMessage("Las contraseñas no coinciden");
            return;
        }
        if (error) {
            setErrores(prevState => ({
                ...prevState,
                password: true,
                repeat_password: true
            }))
            setMessage("La contraseña ingresada no cumple con los estandartes solicitados");
            return;
        } // Si la contraseña no cumple con los entadartes

        const existeDocumento = await validarSiExisteDocumento(
            value.DocumentoDeIdentificacion.TipoDocumentoDeIdentificacionId,
            value.DocumentoDeIdentificacion.numero
        );
        const existeUID = await validarSiExisteUID(value.uid);

        if (existeDocumento) {
            setMessage(
                "Ya existe un usuario con el número y tipo de documento ingresado"
            );
            return;
        }

        if (existeUID) {
            setMessage("Ya existe un usuario con el nombre de usuario ingresado");
            return;
        }

        await scrollToTop();

        if (type === "Modificar")

            await axiosInstance({
                method: 'PUT',
                url: RUTA_API_USUARIOS + '/users/' + prev.uid,
                data: value
            }).then(response => {
                setSuccess("El usuario se modifico con exito")
                closeModal()
                getAltasPendientes()
                setLoading(false)
            }).catch(error => {
                setMessage("Hubo un error al querer persistir el usuario (Código de error: 61)")
                setLoading(false)
            })
        else {
            if (searchParams.get('uuid'))
                await axios({
                    method: 'POST',
                    url: RUTA_API_USUARIOS + '/users/' + searchParams.get('uuid'),
                    data: value
                }).then(response => {
                    window.location.href = window.location.origin + '/usuarios/finalizado'
                    resetearForm()
                }).catch(error => {
                    setMessage("Hubo un error al querer persistir el usuario (Código de error: 62)")
                    setLoading(false)
                })
            else
                await axiosInstance({
                    method: 'POST',
                    url: RUTA_API_USUARIOS + '/users/',
                    data: value
                }).then(response => {
                    window.location.href = window.location.origin + '/usuarios/finalizado'
                    resetearForm()
                }).catch(error => {
                    setMessage("Hubo un error al querer persistir el usuario (Código de error: 63)")
                    setLoading(false)
                })
        }

    }


    async function validarSiExisteDocumento(tipoDocumentoId, numeroDocumento) {
        const validationMap = {
            "Documento Unico de Identidad": "DNI",
            "Libreta Civica": "LC",
            "Libreta de Enrolamiento": "LE",
            Pasaporte: "PAS",
        };

        const tipoDocumento = tiposDocumentoDeIdentificacion.find(
            (tipo) => tipo.id == tipoDocumentoId
        );

        const tipoDocumentoNombre = tipoDocumento
            ? validationMap[tipoDocumento.nombre]
            : null;

        try {
            const response = await axios({
                method: "GET",
                url:
                    RUTA_API_USUARIOS +
                    `/ldap/users/exist/person?tipoDocumento=${tipoDocumentoNombre}&numeroDocumento=${numeroDocumento}`,
            });

            return response.data;
        } catch (error) {
            setMessage("Hubo un error al querer validar si existe el documento");
            setLoading(false);
        }
    }

    async function validarSiExisteUID(uid) {

        try {
            const response = await axios({
                method: "GET",
                url:
                    RUTA_API_USUARIOS +
                    `/ldap/users/exist/person?uid=${uid}`,
            });

            return response.data;
        } catch (error) {
            setMessage("Hubo un error al querer validar si existe el uid");
            setLoading(false);
        }
    }


    function validateForm() {
        let validation = validationSchema.validate(value);
        if (validation.error)
            if (validation.error.details[0].path[0] === 'Direccion')
                return validation.error.details[0].path[1];
            else
                return validation.error.details[0].path[0]
    }

    const validaciones = {
        id: Joi.number().integer().allow(null),
        nombre: Joi.string().min(3).max(150).required(),
        apellido: Joi.string().min(3).max(150).required(),
        uid: Joi.string().min(3).max(20).required(),
        frbaEmail: Joi.string().min(10).max(120).email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'ar'] } }).required(),
        fechaNacimiento: Joi.date().required(),
        password: Joi.string().required(),
        telefonoDomiciliario: Joi.string().allow('').allow(null),
        telefonoCelular: Joi.string().allow('').allow(null),
        repeat_password: Joi.string(),
        personalEmail: Joi.string().min(10).max(120).email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'ar'] } }).required(),
        Direccion: Joi.object({
            id: Joi.number().integer(),
            provincia: Joi.string().required().messages({ "any.required": "Seleccione la provincia donde vive" }),
            ciudad: Joi.string().required().messages({ "string.empty": "Seleccione la ciudad donde vive" }),
            calle: Joi.string().required(),
            altura: Joi.number().integer().min(1).required(),
            codigoPostal: Joi.number().integer().min(1).required()
        }),
        DocumentoDeIdentificacion: Joi.object({
            id: Joi.number().integer(),
            numero: Joi.number().integer().min(1).required(),
            TipoDocumentoDeIdentificacionId: Joi.number().integer().min(1).required(),
        }),
        SexoId: Joi.number()
            .integer()
            .min(1)
            .max(6).required(),
        EstadoCivilId: Joi.number()
            .integer()
            .min(1)
            .max(7).required(),
        estado_civil_id: Joi.number()
            .integer()
            .min(1)
            .max(7).allow(null),
        nacionalidad: Joi.string().required(),
        filiaciones: Joi.array().min(1).required(),
        Filiacions: Joi.array().min(1).required(),
        SedeId: Joi.number().integer().min(1).max(4),
        legajoAlumno: Joi.string().min(1).max(7).allow(''),
        legajoPersonaUTN: Joi.string().min(1).max(7).allow('').allow(null),
    }

    if (!mostrarContrasena) {
        delete validaciones.password
        delete validaciones.repeat_password
    }

    const validationSchema = Joi.object(validaciones);

    const mensajeAlertaFalloFormulario = (fallo) => {
        if (fallo === "apellido") setMessage("El apellido debe tener entre 3 y 150 caracteres");
        if (fallo === "nombre") setMessage("El nombre debe tener entre 3 y 150 caracteres");
        if (fallo === "uid") setMessage("El uid deben tener entre 3 y 20 caracteres");
        if (fallo === "frbaEmail") setMessage("El formato del Email Institucional es invalido");
        if (fallo === "fechaNacimiento") setMessage("El formato de la fecha de nacimiento es erroneo");
        if (fallo === "SexoId") setMessage("Debe seleccionar un genero");
        if (fallo === "EstadoCivilId") setMessage("Debe seleccionar un estado civil");
        if (fallo === "legajoAlumno") setMessage("El legajo de alumno ingresado es erroneo");
        if (fallo === "legajoPersonaUTN") setMessage("El legajo de personal UTN ingresado es erroneo");
        if (fallo === "nacionalidad") setMessage("Seleccione el país correspondiente a su nacionalidad");
        if (fallo === "personalEmail") setMessage("El mail personal es invalido");
        if (fallo === "Direccion") setMessage("Debe ingresar una dirección valida");
        if (fallo === "DocumentoDeIdentificacion") setMessage("Debe ingresar sus datos de documentación para identificación");
        if (fallo === "filiacion") setMessage("Seleccione una filiación");
        if (fallo === "filiaciones") setMessage("Seleccione una filiación");
        if (fallo === "SedeId") setMessage("Seleccione una sede");
        if (fallo === "password") setMessage("Ingrese su contraseña");
        if (fallo === "repeat_password") setMessage("Repita su contraseña");
        if (fallo === "ciudad") setMessage("Ingrese la ciudad donde vive");
        if (fallo === "provincia") setMessage("Seleccione la provincia donde vive");
        if (fallo === "calle") setMessage("Ingrese una calle valida");
        if (fallo === "codigoPostal") setMessage("Ingrese un codigo postal valido");
        if (fallo === "altura") setMessage("Ingrese una altura valida");
    }

    const scrollToTop = () => {
        document.getElementById('slide-top').scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    const onChange = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value
        });
    }

    const onChangeForOnlyStrings = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value.replace(/[^a-z\s]/gi, '')
        });
    }

    const handleChangeNombreUsuario = (e) => {
        e.persist();
        const nombreUsuario = e.target.value;
        if (validarNombreUsuario(nombreUsuario)) {
            setValue(prevState => ({
                ...prevState,
                [e.target.name]: nombreUsuario,
                frbaEmail: nombreUsuario + EXTENSION_MAIL_INSTITUCIONAL,
            }));
        } else {
            setMessage("El nombre de usuario no debe contener signos.");
        }
    }

    const resetearErrores = () => {
        setErrores({
            apellido: false,
            nombre: false,
            uid: false,
            frbaEmail: false,
            SexoId: false,
            SedeId: false,
            Direccion: false,
            FiliacionId: false,
            fechaNacimiento: false,
            codigoPostal: false,
            telefonoDomiciliario: false,
            telefonoCelular: false,
            personalEmail: false,
            legajoAlumno: false,
            legajoPersonaUTN: false,
            nacionalidad: false,
            DocumentoDeIdentificacion: false,
            password: false,
            repeat_password: false,
        })
    }

    const handleChange = (event) => {
        setValue(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleChangeFechaNacimiento = (event) => {
        var fecha = event.$d.toString()

        setValue(prevState => ({
            ...prevState,
            fechaNacimiento: fecha,
        }))
        setFechaNacimiento(event)
    }

    const handleChangeDireccionCalle = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                calle: event.target.value,
            },
        }))
    }

    const handleChangeDireccionAltura = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                altura: event.target.value.replace(/\D/g, ''),
            },
        }))
    }

    const handleChangeDireccionCiudad = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                ciudad: event.target.value,
            },
        }))
    }

    const handleChangeDireccionProvincia = (event) => {
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                provincia: event.target.value,
            },
        }))
    }

    const handleChangeDireccionCodigoPostal = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                codigoPostal: event.target.value.replace(/\D/g, ''),
            },
        }))
    }

    /** 
     * Se divide así por temas de performance en el event de React
     */
    const handleChangeNumeroDocumento = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            DocumentoDeIdentificacion: {
                ...prevState.DocumentoDeIdentificacion,
                numero: event.target.value.replace(/\D/g, ''),
            }
        }))
    }

    const onChangeForOnlyDigits = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value.replace(/\D/g, '')
        });
    }

    const handleChangeTipoDocumento = (event) => {
        setValue(prevState => ({
            ...prevState,
            DocumentoDeIdentificacion: {
                ...prevState.DocumentoDeIdentificacion,
                TipoDocumentoDeIdentificacionId: event.target.value
            }
        }))
    }

    return (
        <Box>
            {loading ? <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            > <CircularIndeterminate /> </Grid>
                :
                <>
                    <Box sx={{ px: type === "Modificar" ? 0 : { xs: "30px", md: "125px", lg: "250px", xl: "300px" }, py: "30px" }}>
                        <div id="slide-top" />
                        <FormWithoutStyle onSubmit={handleSubmit} >
                            <Box sx={{ py: type === "Modificar" ? 0 : 5, boxShadow: type === "Modificar" ? 0 : 3 }}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><PersonIcon /> </Avatar></div>
                                        <br />
                                        <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                            Datos personales
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container
                                    spacing={2}
                                    justifyContent="center"
                                >
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="apellido"
                                            label="Apellido/s"
                                            error={errores.apellido}
                                            value={value.apellido}
                                            onChange={(e) => { onChangeForOnlyStrings(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="nombre"
                                            label="Nombre/s"
                                            error={errores.nombre}
                                            value={value.nombre}
                                            onChange={(e) => { onChangeForOnlyStrings(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="uid"
                                            label="Nombre de Usuario"
                                            error={errores.uid}
                                            value={value.uid}
                                            onChange={handleChangeNombreUsuario}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            disabled
                                            fullWidth
                                            required
                                            name="frbaEmail"
                                            label="Email Institucional"
                                            error={errores.frbaEmail}
                                            value={value.frbaEmail}
                                            onChange={(e) => { onChange(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="personalEmail"
                                            label="Email personal"
                                            error={errores.personalEmail}
                                            value={value.personalEmail}
                                            onChange={(e) => { onChange(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                                            <DateField required error={errores.fechaNacimiento} value={fechaNacimiento} fullWidth onChange={handleChangeFechaNacimiento} format="DD/MM/YYYY" label="Fecha de nacimiento" />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormControl fullWidth>
                                            <InputLabel required id="select-sexo-label">Género:</InputLabel>
                                            <Select
                                                name="SexoId"
                                                required
                                                color="primary"
                                                error={errores.SexoId}
                                                labelId="select-area-label"
                                                label="Genero"
                                                id="select-sexo"
                                                value={value.SexoId}

                                                onChange={handleChange}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione su genero *</em>
                                                </MenuItem>
                                                {sexos.map(sexo => <MenuItem key={sexo.id} value={sexo.id}>{sexo.nombre}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormControl fullWidth>
                                            <InputLabel required id="select-estadocivil-label">Estado Civil:</InputLabel>
                                            <Select
                                                name="EstadoCivilId"
                                                required
                                                color="primary"
                                                error={errores.EstadoCivilId}
                                                labelId="select-area-label"
                                                label="EstadoCivil"
                                                id="select-estadocivil"
                                                value={value.EstadoCivilId}

                                                onChange={handleChange}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione su estado civil *</em>
                                                </MenuItem>
                                                {estadosCiviles.map(estadoCivil => <MenuItem key={estadoCivil.id} value={estadoCivil.id}>{estadoCivil.nombre}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="telefonoCelular"
                                            label="Telefono celular"
                                            error={errores.telefonoCelular}
                                            value={value.telefonoCelular}
                                            onChange={(e) => { onChangeForOnlyDigits(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            name="telefonoDomiciliario"
                                            label="Telefono de su domicilio"
                                            error={errores.telefonoDomiciliario}
                                            value={value.telefonoDomiciliario}
                                            onChange={(e) => { onChangeForOnlyDigits(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormControl fullWidth >
                                            <InputLabel required id="select-nacionalidad-label">Nacionalidad:</InputLabel>
                                            <Select
                                                name="nacionalidad"
                                                color="primary"
                                                error={errores.nacionalidad}
                                                labelId="select-nacionalidad-label"
                                                label="Nacionalidad"
                                                id="select-nacionalidad"
                                                value={value.nacionalidad}

                                                onChange={handleChange}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione su nacionalidad *</em>
                                                </MenuItem>
                                                {paises.map(pais => <MenuItem key={pais} value={pais}>{pais}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormControl fullWidth>
                                            <InputLabel required id="select-sexo-label">Tipo de documento:</InputLabel>
                                            <Select
                                                name="tiposDocumentoDeIdentificacion"
                                                color="primary"
                                                required
                                                error={errores.Documento}
                                                labelId="select-area-label"
                                                label="Tipo de documento de identificación"
                                                id="select-documento"
                                                value={value.DocumentoDeIdentificacion.TipoDocumentoDeIdentificacionId}

                                                onChange={handleChangeTipoDocumento}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione Tipo *</em>
                                                </MenuItem>
                                                {tiposDocumentoDeIdentificacion.map(tipo => <MenuItem key={tipo.id} value={tipo.id}>{tipo.nombre}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="numero"
                                            label="Numero de documento"
                                            error={errores.DocumentoDeIdentificacion}
                                            value={value.DocumentoDeIdentificacion.numero}
                                            onChange={handleChangeNumeroDocumento}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><HomeIcon /> </Avatar></div>
                                        <br />
                                        <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                            Datos de domicilio
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container
                                    spacing={2}
                                    justifyContent="center">
                                    <Grid item xs={11}>
                                        <FormControl fullWidth>
                                            <InputLabel required id="select-sexo-label">Provincia:</InputLabel>
                                            <Select
                                                required
                                                name="provincia"
                                                color="primary"
                                                error={errores.provincia}
                                                labelId="select-area-label"
                                                label="Provincia"
                                                id="select-provincia"
                                                value={value.Direccion.provincia}
                                                fullwidth
                                                onChange={handleChangeDireccionProvincia}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione una provincia *</em>
                                                </MenuItem>
                                                {provincias.map(provincia => <MenuItem key={provincia.nombre} value={provincia.nombre}>{provincia.nombre}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="ciudad"
                                            label="Ciudad"
                                            error={errores.ciudad}
                                            value={value.Direccion.ciudad}
                                            onChange={handleChangeDireccionCiudad}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="calle"
                                            label="Calle"
                                            error={errores.calle}
                                            value={value.Direccion.calle}
                                            onChange={handleChangeDireccionCalle}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="altura"
                                            label="Altura"
                                            error={errores.altura}
                                            value={value.Direccion.altura}
                                            onChange={handleChangeDireccionAltura}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            required
                                            name="codigoPostal"
                                            label="Codigo postal"
                                            error={errores.codigoPostal}
                                            value={value.Direccion.codigoPostal}
                                            onChange={handleChangeDireccionCodigoPostal}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                        />
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><CorporateFareIcon /> </Avatar></div>
                                        <br />
                                        <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                            Datos laborales
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <br />
                                <Grid container
                                    spacing={2}
                                    justifyContent="center">
                                    <Grid item xs={11}>
                                        <FormControl fullWidth error={errores.filiaciones || errores.filiacion}>
                                            <InputLabel required id="demo-multiple-chip-label">Filiacion</InputLabel>
                                            <Select
                                                labelId="demo-multiple-chip-label"
                                                id="demo-multiple-chip"

                                                multiple
                                                fullWidth
                                                required
                                                value={filiacionesSeleccionadas}
                                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                                renderValue={(selected) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value} />
                                                        ))}
                                                    </Box>
                                                )}
                                                MenuProps={MenuProps}
                                            >
                                                {filiaciones.map((filiacion) => (
                                                    <MenuItem
                                                        key={filiacion.id}
                                                        value={filiacion.nombre}
                                                        onClick={(e) => handleChangeFiliacionOption(filiacion.id, filiacion.nombre)}
                                                        style={getStyles(filiacion.nombre, value.filiaciones, theme)}
                                                    >
                                                        {filiacion.nombre}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={11}>
                                        <FormControl fullWidth>
                                            <InputLabel required id="select-sexo-label">Sede:</InputLabel>
                                            <Select
                                                required
                                                name="SedeId"
                                                color="primary"
                                                error={errores.SedeId}
                                                labelId="select-area-label"
                                                label="Sedes"
                                                id="select-sede"
                                                value={value.SedeId}
                                                fullwidth
                                                onChange={handleChange}
                                            >
                                                <MenuItem value={0}>
                                                    <em>Seleccione su sede *</em>
                                                </MenuItem>
                                                {sedes.map(sede => <MenuItem key={sede.id} value={sede.id}>{sede.nombre}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {mostrarLegajoAlumno ?
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="legajoAlumno"
                                                label="Legajo Alumno (Solo llenar en caso de tenerlo)"
                                                error={errores.legajoAlumno}
                                                value={value.legajoAlumno}
                                                onChange={(e) => {
                                                    onChange(e)
                                                }}
                                                onKeyPress={(e) => {
                                                    e.key === 'Enter' && e.preventDefault()
                                                }}
                                            />
                                        </Grid> : null}
                                    <Grid item xs={11}>
                                        <FormInput
                                            fullWidth
                                            name="legajoPersonaUTN"
                                            label="Legajo Persona (Solo llenar en caso de tenerlo)"
                                            error={errores.legajoPersonaUTN}
                                            value={value.legajoPersonaUTN}
                                            onChange={(e) => { onChange(e) }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                    </Grid>
                                </Grid>
                                <br />
                                {mostrarContrasena ? <> <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center'
                                        }}><Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><LockIcon /> </Avatar>
                                        </div>
                                        <br />
                                        <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                            Contraseña
                                        </Typography>
                                    </Grid>
                                </Grid>
                                    <br />

                                    <Grid container
                                        spacing={2}
                                        justifyContent="center">
                                        <Grid item xs={8}>
                                            {error ? <Alert severity="error">
                                                {errorMsg}
                                            </Alert> : null}
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                required
                                                name="password"
                                                label="Ingrese su contraseña"
                                                error={errores.password || error}
                                                value={value.password}
                                                type="password"
                                                onChange={(e) => {
                                                    onChange(e)
                                                    handleValidation(e)
                                                }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                required
                                                fullWidth
                                                name="repeat_password"
                                                label="Confirme su contraseña"
                                                error={errores.repeat_password}
                                                value={value.repeat_password}
                                                type="password"
                                                onChange={(e) => { onChange(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                                    : null}
                                <br />
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <SaveButton label={"Guardar Datos"} onClick={handleSubmit} type="button" />
                                </Grid>
                            </Box>
                        </FormWithoutStyle>
                    </Box>
                </>
            }
        </Box >
    )
}